import { PolicyHolderInfo } from '../policy-holder/policy-holder-info';
import { InsuredInfo } from '../insured/insured-info';

export class PolicyContractInfo {
	// public 変数 ------------------------------------------------------------------------
	public policyHolderInfo:	PolicyHolderInfo	= null;    // 契約者情報
	public insuredInfoList:		InsuredInfo[]		= null;    // 
	// ------------------------------------------------------------------------------------
}
  